import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsCircuitBreakerIP, MultiOptDetails_1DS, OptionsConnectedDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-circuit-breaker',
  templateUrl: './ds-circuit-breaker.component.html',
  styleUrls: ['./ds-circuit-breaker.component.css']
})
export class DsCircuitBreakerComponent implements OnInit, OnChanges {
  
    @Input() dsCircuitBreakerObj: DsCircuitBreakerIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock
  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      if (!this.dsCircuitBreakerObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
      this.defaultSelMaxDc();
      this.getDiElectricName();
      this.wattageDefultValues();
  
    }

  addNewUvCoilDtBlock() {
    this.dsCircuitBreakerObj.addUvCoilDetailDS(new MultiOptDetails_1DS(""));
  }
  removeUvCoilDtBlock(_crDS: MultiOptDetails_1DS) {
    if (_crDS) {
      this.dsCircuitBreakerObj.removeUvCoilDetailDS(_crDS);
    }
  }

  wattageDefultValues(){
    this.dsCircuitBreakerObj.cbWattCloseCoil =
        this._dataService.getCloseTripCircName(this.dsCircuitBreakerObj.parentDSRef.dsControlAuxIP.closeTripCirc).includes('AC') ? "AC-5VA/200VA" : "DC-5W/200W";
    this.dsCircuitBreakerObj.cbWattTripCoil =
        this._dataService.getCloseTripCircName(this.dsCircuitBreakerObj.parentDSRef.dsControlAuxIP.closeTripCirc).includes('AC') ? "AC-5VA/200VA" : "DC-5W/200W";
    this.dsCircuitBreakerObj.cbWattAddTripCoil =
        this._dataService.getAddTripCoilName(this.dsCircuitBreakerObj.parentDSRef.dsControlAuxIP.addTripCoilCirc).includes('AC') ? "AC-5VA/200VA" : "DC-5W/200W";
    this.dsCircuitBreakerObj.cbWattSpringChg =
        this.dsCircuitBreakerObj.parentDSRef.dsControlAuxIP.springChargingMotor.includes('AC') ? "AC-50W/200W" : "DC-50W/200W";
  }

  cachedMaxDc: any = {};
  filterMaxDc() {
    let _id = this.dsCircuitBreakerObj.parentDSRef.dsPanelIP.vcbModelDetail;
    if (this.cachedMaxDc[_id] != null) {
      return this.cachedMaxDc[_id];
    }
    this.cachedMaxDc[_id] = this._dataService.maxDCComp.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    if (this.cachedMaxDc[_id] != null) {
      return this.cachedMaxDc[_id];
    }
    var _result = !this._dataService.isGeneralMaxDCComp(_id);
    this.cachedMaxDc[_id] = _result;
    return _result;
  }

  defaultSelMaxDc(){ // Logic for default selection
    if(this.dsCircuitBreakerObj.parentDSRef.dsPanelIP.vcbModelName == "004" && this.dsCircuitBreakerObj.parentDSRef.dsPanelIP.vcbModelDetail !=""){ // Special Requirement
      this.dsCircuitBreakerObj.maxDCComp = "001"; // By Default
    }
  }

  filterVacCont(){
    if(this.dsCircuitBreakerObj.vacContactor == '001'){ // If Required
      this.dsCircuitBreakerObj.vacContType = "001";
      this.dsCircuitBreakerObj.cbCloseTripVolt = "003"; // Default 110 VAC
    }
    else{
      this.dsCircuitBreakerObj.vacContType = "";
      this.dsCircuitBreakerObj.cbCloseTripVolt = "";
    }
  }
   
  getDiElectricName(){
    let _tmpPanelModel = this.dsCircuitBreakerObj.parentDSRef.dsPanelIP.vcbModelName;
    let _tmpPanelModelDetail = this.dsCircuitBreakerObj.parentDSRef.dsPanelIP.vcbModelDetail;

    if(_tmpPanelModel == "001" || _tmpPanelModel == "003"){ // VD4 or Vind
      this.dsCircuitBreakerObj.diElect = "Vaccum"; 
    }
    else if(_tmpPanelModel == "003"){ // HD4 
      this.dsCircuitBreakerObj.diElect = "SF6"; 
    }
    else if(_tmpPanelModel == "004"){ // Special Requirement
      // Keep the existing selection
      if(_tmpPanelModelDetail == "001" || _tmpPanelModelDetail == "002" || _tmpPanelModelDetail == "003"){ // SF6 or Air Blast
        this.dsCircuitBreakerObj.diElect = "Vaccum"; 
      }
      else if(_tmpPanelModelDetail == "004"){
        this.dsCircuitBreakerObj.diElect = "Vacuum + SF6";
      }
    }
  }
  sectionNoteChangePM(_event: any) {
    this.dsCircuitBreakerObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsCircuitBreakerObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsCircuitBreakerObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
            (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
      }
    }
    reloadData(){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
      }
    }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("Dynamic Peak Withstand Current", !!this.dsCircuitBreakerObj.cbDynamicPeakCurr, " required to save Datasheet."),
        new ValidationItem("Maximum DC Component", !!this.dsCircuitBreakerObj.maxDCComp, " required to save Datasheet."),
        new ValidationItem("Rated Making Current", !!this.dsCircuitBreakerObj.ratedMkCurr, " required to save Datasheet."),
        new ValidationItem("UV Coil", !!this.dsCircuitBreakerObj.uvCoil, " required to save Datasheet."),
        new ValidationItem("EE Note", !!this.dsCircuitBreakerObj.sectionNoteEE, " required to save Datasheet.")
      );
      if (this.dsCircuitBreakerObj.isMaxDCSpecReqApplicable) {
        _validList.push(new ValidationItem("Max DC Component Detail", !!this.dsCircuitBreakerObj.maxDCCompDetail, " required to save Datasheet."));
      }
      if (this.dsCircuitBreakerObj.uvCoilDetailApplicable) {
        _validList.push(new ValidationItem("UV Coil Control Voltage", !!this.dsCircuitBreakerObj.cbConVoltUVCoil, " required to save Datasheet."));
      }
      if (this.dsCircuitBreakerObj.uvCoilDetail_Enable) {
        for (let i = 0; i < this.dsCircuitBreakerObj.uvCoilDetail.length; i++) {
          _validList.push(new ValidationItem("UV Coil Feeder #" + (i + 1), !!this.dsCircuitBreakerObj.uvCoilDetail[i].type1, " required to save Datasheet."));
        }
      }
      if (this.dsCircuitBreakerObj.vacuumCont_Enable) {
        _validList.push(new ValidationItem("Vacuum Contactor", !!this.dsCircuitBreakerObj.vacContactor, " required to save Datasheet."));
      }
    }

    if (this.hasAccessME) {
      _validList.push(
        new ValidationItem("Castle Lock Requirement", !!this.dsCircuitBreakerObj.cbCastleRockReq, " required to save Datasheet."),
        new ValidationItem("ME Note", !!this.dsCircuitBreakerObj.sectionNoteME, " required to save Datasheet.")
      );
    }

    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsCircuitBreakerObj.sectionNotePM, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsCircuitBreakerObj.cbDynamicPeakCurr || !this.dsCircuitBreakerObj.maxDCComp ||
        !this.dsCircuitBreakerObj.ratedMkCurr || !this.dsCircuitBreakerObj.uvCoil ||
        !this.dsCircuitBreakerObj.sectionNoteEE) {
        return false;
      }
      if (this.dsCircuitBreakerObj.isMaxDCSpecReqApplicable && !this.dsCircuitBreakerObj.maxDCCompDetail) return false;
      if (this.dsCircuitBreakerObj.uvCoilDetailApplicable && !this.dsCircuitBreakerObj.cbConVoltUVCoil) return false;
      if (this.dsCircuitBreakerObj.uvCoilDetail_Enable) {
        for (let uv of this.dsCircuitBreakerObj.uvCoilDetail) {
          if (!uv.type1) return false;
        }
      }
      if (this.dsCircuitBreakerObj.vacuumCont_Enable && !this.dsCircuitBreakerObj.vacContactor) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsCircuitBreakerObj.cbCastleRockReq || !this.dsCircuitBreakerObj.sectionNoteME) return false;
    }
    if (this.hasAccessPM) {
      if (!this.dsCircuitBreakerObj.sectionNotePM) return false;
    }
    return true;
  }

}

